<template>
    <section class="p-3">
        <header class="d-flex justify-content-between align-items-center">
            <h6 class="fw-bold">Add Branch</h6>
            <button type="button" class="btn table-btn px-2 btn-outline-info" @click="closeDialog">
                <i class="fas fa-close icon-size"></i>
            </button>
        </header>
        <div class="h-100 d-flex flex-column mb-3 mt-2">
            <div class="d-flex justify-content-between w-70">
                <div class="form-group me-2">
                    <label for="agency-branch"> Agency Branch <span class="text-danger">*</span></label>
                    <select class="form-select" v-model="selectedAgencyBranch" @blur="v$.selectedAgencyBranch.$touch">
                        <option :value="null">Select Branch</option>
                        <option v-for="location of agencyBranches" :value="location.id">
                            {{ location.name }}
                        </option>
                    </select>
                    <span v-if="v$.selectedAgencyBranch.$error" class="field-invalid">Agency Branch is required.</span>
                </div>
                <div class="form-group">
                    <label for="effective-date"> Effective Date <span class="text-danger">*</span></label>
                    <DatePicker :getDate="changeDate">
                        <div class="input-group date datepickerInput">
                            <input
                                type="text"
                                name="effectiveDate"
                                class="form-control rounded-0 border-end-0"
                                placeholder="MM/DD/YYYY"
                                v-model="effectiveDate"
                                @blur="v$.effectiveDate.$touch"
                            />
                            <div class="input-group-addon input-group-append">
                                <div class="input-group-text">
                                    <i class="fa fa-calendar"></i>
                                </div>
                            </div>
                        </div>
                        <span v-if="v$.effectiveDate.$error" class="field-invalid">Effective Date is required.</span>
                    </DatePicker>
                </div>
            </div>
            <div class="form-group w-70">
                <label for="comment"> Comments</label>
                <textarea maxlength="2000" class="form-control" v-model="comments"></textarea>
            </div>
            <div class="d-flex align-items-center justify-content-center">
                <button type="button" class="btn btn-primary btn-md me-2" @click="handleAddBranch">
                    <span v-if="isSaving"> <i class="fa fa-spinner fa-spin animated slow flash infinite"></i> </span
                    ><span v-else>Save</span>
                </button>

                <button type="button" class="btn btn-outline-primary btn-md" @click="handleCancel">Cancel</button>
            </div>
        </div>
    </section>
</template>

<script lang="ts" src="./ReferralAddBranch.ts"></script>
